import { Routes } from '@src/pages';
import { Loader } from './loader';
import { Mui, Router, Store } from './providers';
import 'sanitize.css';
import './styles/index.scss';
import { queryClient } from '@src/api/query-client.ts';
import { QueryClientProvider } from '@tanstack/react-query';

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Mui>
        <Store>
          <Router>
            <Routes />
            <Loader />
          </Router>
        </Store>
      </Mui>
    </QueryClientProvider>
  );
};
